export default __webpack_public_path__ + "static/media/hero-image.d38cc01e.png";